module.exports = __webpack_public_path__ + "img/cn-bg-brushes.fd3ecc0.png";